export default {
  form: {
    amount: {
      label: 'Precio',
    },
    has_sales_based_discount: {
      label: 'Descuentos según ventas mensuales',
    },
  },
  labels: {
    month: 'mes',
    varies_by_tier: 'varía según nivel',
    max_price: '* El precio máximo es {{amount}}',
    sales_based_discount:
      'hasta +{{threshold}} de ventas mínimas en un mes. Después, precio regular {{amount}} neto/mes',
  },
  tax: {
    inclusive: '{{taxName}}: {{tax}} (incluido)',
    exclusive: 'por mes más {{taxName}}: {{tax}}',
  },
  buttons: {
    select: 'Seleccionar',
    save: 'Guardar',
    use_default_price: 'Usar precio predeterminado',
  },
};
